import React, { Component } from 'react';
import { connect } from 'react-redux';

import Voltar from '../../components/Links/Voltar';
import Loading from '../../components/Loading';
import * as actions from '../../actions/entregadores';

/** Divide uma linha CSV por vírgulas, respeitando aspas RFC 4180 (iterativo, caráter a caráter). */
function parseCsvLine(line) {
	const cols = [];
	let cur = '';
	let i = 0;
	let inQuotes = false;
	while (i < line.length) {
		const c = line[i];
		if(inQuotes){
			if(c === '"' && line[i + 1] === '"'){
				cur += '"';
				i += 2;
				continue;
			}
			if(c === '"'){
				inQuotes = false;
				i++;
				continue;
			}
			cur += c;
			i++;
		}else{
			if(c === '"'){
				inQuotes = true;
				i++;
				continue;
			}
			if(c === ','){
				cols.push(cur.trim());
				cur = '';
				i++;
				continue;
			}
			cur += c;
			i++;
		}
	}
	cols.push(cur.trim());
	return cols;
}

function normalizeTelefoneKey(telefone) {
	return String(telefone).replace(/\D/g, '');
}

/** Mantém a primeira ocorrência de cada telefoneWhatsApp (só dígitos). */
function deduplicarItens(itens) {
	const seen = new Set();
	const unicos = [];
	let omitidosArquivo = 0;
	for (const item of itens) {
		const key = normalizeTelefoneKey(item.telefoneWhatsApp);
		if (!key || seen.has(key)) {
			omitidosArquivo++;
			continue;
		}
		seen.add(key);
		unicos.push(item);
	}
	return { itens: unicos, omitidosArquivo };
}

class ImportarEntregadoresLote extends Component {

	state = {
		formato: 'json',
		texto: '',
		salvando: false,
	};

	onFormat = (ev) => this.setState({ formato: ev.target.value });

	onTexto = (ev) => this.setState({ texto: ev.target.value });

	onArquivo = (ev) => {
		const input = ev.target;
		const f = input.files && input.files[0];
		input.value = '';
		if(!f) return;
		const leitor = new FileReader();
		leitor.onload = () => {
			const resultado = typeof leitor.result === 'string' ? leitor.result : '';
			this.setState({ texto: resultado });
		};
		leitor.readAsText(f, 'UTF-8');
	};

	montarItensJson = () => {
		const raw = JSON.parse(this.state.texto);
		if(!Array.isArray(raw)){
			throw new Error('O JSON deve ser um array de objetos com nome e telefoneWhatsApp.');
		}
		const itens = [];
		for(let i = 0; i < raw.length; i++){
			const row = raw[i];
			if(!row || typeof row !== 'object'){
				throw new Error(`Posição ${i + 1}: cada item deve ser um objeto.`);
			}
			const { nome, telefoneWhatsApp } = row;
			if(typeof nome !== 'string' || !nome.trim()){
				throw new Error(`Posição ${i + 1}: campo nome é obrigatório (texto).`);
			}
			if(typeof telefoneWhatsApp !== 'string' || !telefoneWhatsApp.trim()){
				throw new Error(`Posição ${i + 1}: campo telefoneWhatsApp é obrigatório (texto).`);
			}
			const item = {
				nome: nome.trim(),
				telefoneWhatsApp: telefoneWhatsApp.trim(),
			};
			if(Object.prototype.hasOwnProperty.call(row, 'ativo')){
				item.ativo = Boolean(row.ativo);
			}
			itens.push(item);
		}
		return itens;
	};

	montarItensCsv = () => {
		const texto = this.state.texto.trim();
		const linhas = texto.split(/\r?\n/).filter((l) => l.trim().length);
		if(linhas.length < 2){
			throw new Error('CSV deve ter uma linha de cabeçalho e pelo menos uma linha de dados.');
		}
		const headerCells = parseCsvLine(linhas[0]).map((h) =>
			h.replace(/\s+/g, '').toLowerCase()
		);
		const iNome = headerCells.indexOf('nome');
		const iTel = headerCells.indexOf('telefonewhatsapp');
		if(iNome === -1 || iTel === -1){
			throw new Error('Primeira linha do CSV deve conter as colunas nome e telefoneWhatsApp.');
		}
		const itens = [];
		for(let L = 1; L < linhas.length; L++){
			const cols = parseCsvLine(linhas[L]);
			const nome = (cols[iNome] || '').trim();
			const telefoneWhatsApp = (cols[iTel] || '').trim();
			if(!nome && !telefoneWhatsApp) continue;
			if(!nome || !telefoneWhatsApp){
				throw new Error(`Linha ${L + 1}: nome e telefoneWhatsApp são obrigatórios.`);
			}
			itens.push({ nome, telefoneWhatsApp });
		}
		if(itens.length === 0){
			throw new Error('Nenhuma linha de dados válida no CSV.');
		}
		return itens;
	};

	_ehErroAction = (data) => {
		if(!data) return true;
		if(data.status && data.message){
			window.alert(data.message);
			return true;
		}
		if(data.error){
			window.alert(typeof data.error === 'string' ? data.error : 'Erro ao processar.');
			return true;
		}
		return false;
	};

	importar = () => {
		const { usuario } = this.props;
		const { formato, texto, salvando } = this.state;
		if(!usuario || salvando) return;
		if(!texto.trim()){
			window.alert('Cole o conteúdo ou escolha um arquivo.');
			return;
		}
		let itens;
		try {
			if(formato === 'json'){
				itens = this.montarItensJson();
			}else{
				itens = this.montarItensCsv();
			}
		}catch(e){
			const msg = e instanceof SyntaxError
				? 'JSON inválido: sintaxe incorreta.'
				: (e.message || String(e));
			window.alert(msg);
			return;
		}
		const { itens: itensUnicos, omitidosArquivo } = deduplicarItens(itens);
		let msgConfirm = `${itensUnicos.length} entregador(es) serão processados`;
		if(omitidosArquivo > 0){
			msgConfirm += ` (${omitidosArquivo} duplicata(s) no arquivo serão ignoradas)`;
		}
		msgConfirm += '. Duplicatas já cadastradas na loja também serão ignoradas. Continuar?';
		if(window.confirm(msgConfirm)){
			this.setState({ salvando: true });
			this.props.createEntregadoresLote(usuario.loja, itens)
				.then((data) => {
					this.setState({ salvando: false });
					if(this._ehErroAction(data)) return;
					const n = typeof data.total === 'number' ? data.total : (data.entregadores || []).length;
					const omitidos = typeof data.omitidos === 'number' ? data.omitidos : 0;
					let msg = `${n} entregador(es) cadastrado(s).`;
					if(omitidos > 0){
						msg += ` ${omitidos} duplicata(s) ignorada(s).`;
					}
					window.alert(msg);
					this.props.history.push('/entregadores');
				});
		}
	};

	render(){
		const { usuario } = this.props;
		const { formato, texto, salvando } = this.state;

		if(!usuario) return <Loading />;

		return (
			<div className="Category container-centered ImportarEntregadores">
				<div className="head">
					<Voltar path="/entregadores" />
					<h1>Importar entregadores em lote</h1>
				</div>a

				<div className="items entregadoresForm">
					<p className="ImportarEntregadores-hint">
						Escolha o formato abaixo. <strong>JSON:</strong> array de objetos com <code>nome</code> e{' '}
						<code>telefoneWhatsApp</code> (opcional: <code>ativo</code>).{' '}
						<strong>CSV:</strong> separador vírgula; primeira linha{' '}
						<code>nome,telefoneWhatsApp</code> (ou com aspas em nomes que tenham vírgula).
					</p>

					<div className="ImportarEntregadores-formato">
						<label className={formato === 'json' ? 'ImportarEntregadores-opt is-on' : 'ImportarEntregadores-opt'}>
							<input type="radio" name="fmtEntreg" value="json" checked={formato === 'json'} onChange={this.onFormat} />
							<span>JSON</span>
						</label>
						<label className={formato === 'csv' ? 'ImportarEntregadores-opt is-on' : 'ImportarEntregadores-opt'}>
							<input type="radio" name="fmtEntreg" value="csv" checked={formato === 'csv'} onChange={this.onFormat} />
							<span>CSV</span>
						</label>
					</div>

					<label className="ImportarEntregadores-file">
						<span>Arquivo (opcional)</span>
						<input type="file" accept={formato === 'json' ? '.json,.txt,application/json' : '.csv,.txt,text/csv,text/plain'} onChange={this.onArquivo} />
					</label>

					<label className="ImportarEntregadores-textWrap">
						<span>Conteúdo</span>
						<textarea
							className="ImportarEntregadores-textarea"
							value={texto}
							onChange={this.onTexto}
							placeholder={formato === 'json'
								? '[\n  { "nome": "...", "telefoneWhatsApp": "..." }\n]'
								: 'nome,telefoneWhatsApp\nJoão Silva,21999998888'}
							rows={16}
							spellCheck={false}
						/>
					</label>

					<div className="ButtonSubmit">
						<button type="button" onClick={this.importar} disabled={salvando}>{salvando ? 'Importando…' : 'Importar'}</button>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	usuario: state.auth.usuario,
});

export default connect(mapStateToProps, actions)(ImportarEntregadoresLote);
